import _defineProperty from "/var/log/nginx/source/CateringManagerX/CateringManager_Html/node_modules/_@babel_runtime-corejs2@7.13.7@@babel/runtime-corejs2/helpers/esm/defineProperty";

var _name$props$data$prop;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default (_name$props$data$prop = {
  name: "create-folder",
  props: {},
  data: function data() {
    return {
      dialogVisible: false,
      folderName: ""
    };
  }
}, _defineProperty(_name$props$data$prop, "props", {
  courseId: {
    type: String,
    required: true
  },
  folderId: {
    type: String,
    required: "0"
  },
  courseName: {
    type: String,
    required: true
  }
}), _defineProperty(_name$props$data$prop, "methods", {
  handleClose: function handleClose(done) {},
  createFolderHander: function createFolderHander() {
    this.dialogVisible = true;
  },
  addFolder: function addFolder() {
    var _this = this;

    if (!this.folderName) {
      this.$message.warning("章名称不允许为空");
      return false;
    }

    this.$http.post('/api/XOrg/BookMaterial/saveFolder', {
      folderName: this.folderName,
      courseId: this.courseId,
      courseName: this.courseName,
      folderId: this.folderId
    }).then(function (rst) {
      _this.folderName = "";

      _this.$message.success(rst.msg);
    });
    this.dialogVisible = false;
    this.$emit("done");
  }
}), _name$props$data$prop);